import { render, staticRenderFns } from "./ArtigosAiLoading.vue?vue&type=template&id=274f61f7&scoped=true&"
import script from "./ArtigosAiLoading.vue?vue&type=script&lang=js&"
export * from "./ArtigosAiLoading.vue?vue&type=script&lang=js&"
import style0 from "./ArtigosAiLoading.vue?vue&type=style&index=0&id=274f61f7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "274f61f7",
  null
  
)

export default component.exports